module.exports = __webpack_public_path__ + "static/img/intro_img_1.aa696dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/intro_img_1.png
// module id = z1QH
// module chunks = 0